module.exports = {"340221100":"湾沚镇","340221101":"六郎镇","340221102":"陶辛镇","340221104":"红杨镇","340221105":"花桥镇","340221400":"安徽新芜经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340221.json
// module id = 1051
// module chunks = 0